import { baseUrl } from "../../http/baseUrl";
import request from '../../http/axios'

export const getDicListByCode = (code) => {
  return request({
    url: baseUrl + '/admin/dictionary/dict/get_list_by_code?code=' + code,
    method: 'get'
  })
}

export const reportForms = (params, code) => {
  return request({
    url: '/portal' + '/admin/report/unify/query/' + code,
    method: 'get',
    params
  })
}

/**
 * 文件下载
 * @param {any} data 参数
 * @param {any} url 下载请求Url
 * @param {any} name 文件名称
 */
export const fileDownload = (data, url, name) => {
  request({
    url: baseUrl + url,
    method: 'post',
    responseType: 'blob',
    data
  }).then(res => {
    // 处理返回的文件流
    const blob = res
    if (blob && blob.size === 0) {
      this.$notify.error('内容为空，无法下载')
      return
    }
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = name + '.xlsx'
    document.body.appendChild(link)
    link.click()
    window.setTimeout(function () {
      window.URL.revokeObjectURL(blob)
      document.body.removeChild(link)
    }, 0)
  })
}



// WEBPACK FOOTER //
// ./src/plugins/api/other/public.js